module.exports = __webpack_public_path__ + "img/awards_1.8df56178.png";